<div [ngClass]="containerClasses">
  <!-- <div class="card-header-container"> -->
  <div class="header-wrapper">
    <div class="header">
      <div *ngIf="header" [ngClass]="headerClasses" class="_card-header">{{ header }}</div>
      <div *ngIf="subHeader" class="_card-sub-header">{{ subHeader }}</div>
    </div>
    <div>
      <div class="_card-action">
        <app-static-tag [color]="tagColor" *ngIf="tagText">{{ tagText }}</app-static-tag>
        <app-button (activated)="activate($event)" *ngIf="action" [disabled]="!actionActive">{{ action }}</app-button>
        <ng-content select="card-action"></ng-content>
      </div>
    </div>
  </div>
  <div class="_card-body">
    <!-- need to add the body? -->
    <ng-content></ng-content>
  </div>
</div>
